












import {Component, Prop, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';

@Component({
  name: 'BigIconPanel'
})
export default class BigIconPanel extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  @Prop({required: true})
  title: string;

  @Prop({required: true})
  text: string;

  @Prop({required: true})
  icon: string;

  @Prop({required: false})
  hasAction: boolean;

  public get classIcon(): string {
    return `${this.icon} icon`;
  }

  public handleClick(): void {
    if (!this.hasAction)
      return;

    this.$emit('click');
  }

  public get containerClass(): string {
    const hasAction: string = this.hasAction ? 'hasAction' : '';
    return `ui icon message ${hasAction}`
  }
}
